import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n";
import { Logo } from "@/components/Logo";

export const Footer = () => {
  const { t } = useLanguage();

  const links = [
    { to: "/#services", label: t.nav.services },
    { to: "/#forfaits", label: t.nav.packages },
    { to: "/#zones", label: t.nav.zones },
    { to: "/#process", label: t.nav.process },
    { to: "/#faq", label: t.nav.faq },
    { to: "/#contact", label: t.nav.contact },
  ];

  return (
    <footer className="bg-obsidian border-t border-hairline" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <Link to="/">
            <Logo />
          </Link>
          <p className="mt-6 font-serif italic text-lg text-slate-400 max-w-xs">{t.footer.tagline}</p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold mb-5">{t.footer.nav}</p>
          <nav className="flex flex-col gap-3">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="text-sm text-slate-400 hover:text-gold transition-colors w-fit">
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-gold mb-5">ATLAS</p>
          <p className="text-xs leading-relaxed text-slate-500">{t.footer.disclaimer}</p>
        </div>
      </div>
      <div className="border-t border-hairline/60">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-600">
          <span>© {new Date().getFullYear()} ATLAS PROPERTY INTELLIGENCE. {t.footer.rights}</span>
          <span className="font-mono tracking-widest">PARIS · BÂLE · SARAJEVO · PRIZREN</span>
        </div>
      </div>
    </footer>
  );
};
